import MyUniverse from "./myUniverse.jsx";

export default MyUniverse;



// WEBPACK FOOTER //
// ./src/components/pages/MyUniverse/universe/index.js